export default function sendClarityEvent(event: string) {
  const global: any = window

  if (global.clarity) {
    global.clarity('event', event)
  }
}
